import moment from "moment";
import React, { Fragment } from "react";
import { Button, Col, Image, Modal, Row, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import CustomSuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import SuperAdminSmsAdmin from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

const ViewDiner = ({
  onClickshowView,
  onClickCloseView,
  onClickshowEdit,
  userData,
}) => {
  const { userId } = useParams();
  const calcTotalPersons = (seating) => {
    let total;
    total =
      seating.adult_count +
      seating.kids_count +
      seating.high_chair +
      seating.handicap_chair;
    return total;
  };

  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(userData && userData.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(userData?.wait_time_date || userData?.updatedAt);
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = userData && userData.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(userData && userData.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  }

  return (
    <>
      <Modal
        show={onClickshowView}
        onHide={onClickCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Diner Details</Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <Image
                //src={require("../../../../assets/images/UserManagement/fhr7.png")}
                src={
                  (userData &&
                    userData.restaurant_id &&
                    userData.restaurant_id.logo_url) ||
                  NOTAVAILABLEIMAGE
                }
                alt="Restaurant logo"
                title="Restaurant logo"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {" "}
                  {userData &&
                    userData.restaurant_id &&
                    userData.restaurant_id.restaurant_name}
                </div>
                <div className="f14-400">
                  {userData &&
                    userData.restaurant_id &&
                    userData.restaurant_id.restaurant_address}
                </div>
              </Col>
            </div>
          </div>
          <hr />
          {/* <div className="f18-700 pb-3">Basic information</div> */}
          <div className="enGrayBorderBox enLeftGReenLine">
            <Row className="px-3">
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Name/Request Number</div>
                <div className="d-flex">
                  <div>
                    <Image
                      src={require("../../../../../assets/images/UserManagement/walkin.svg")}
                      alt="View"
                      title="View"
                      width="9px"
                    />
                  </div>
                  <div className="pl-2">
                    <div className="f15-500">
                      {userData &&
                        userData.user_details &&
                        userData.user_details.name}
                    </div>
                    <div className="f9-400">
                      # #{userData && userData.diner_id}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Total PAX</div>
                <div className="adult-total-box">
                  <div className="d-flex align-items-center">
                    <p className="f18-700 text-dark mr-2">
                      {" "}
                      {userData && userData.adult_count ? (
                        calcTotalPersons(userData)
                      ) : (
                        <> </>
                      )}
                    </p>
                    <div className="adult-total-box-two mr-2">
                      <div className="d-flex align-items-center justify-content-around mb-2">
                        <div className="adult-total-box-two-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/employees.png")}
                            fluid
                            alt="Adult"
                            title="Adult"
                            className="icon-image"
                          />
                        </div>
                        <span className="pl-1">
                          {userData && userData.adult_count}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-around">
                        <div className="adult-total-box-two-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/children.png")}
                            fluid
                            alt="Children"
                            title="Children"
                            className="icon-image"
                          />
                        </div>
                        <span className="pl-1">
                          {userData && userData.kids_count}
                        </span>
                      </div>
                    </div>
                    <div className="adult-total-box-three">
                      <div className="d-flex align-items-center justify-content-around mb-2">
                        <div className="adult-total-box-three-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/highchair.png")}
                            fluid
                            alt="Highchair"
                            title="Highchair"
                            className="icon-image-small"
                          />
                        </div>
                        <span className="pl-1">
                          {userData && userData.high_chair}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-around">
                        <div className="adult-total-box-three-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                            fluid
                            alt="Wheel Chair"
                            title="Wheel Chair"
                            className="icon-image-small"
                          />
                        </div>
                        <span className="pl-1">
                          {userData && userData.handicap_chair}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
             
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Date / Time </div>
                <div className="f12-400 text-red d-flex align-items-center">
                  {/* <Button variant="link" className="enIconBtn enSmallIcon ml-1">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </Button> */}
                </div>
                <div className="f12-400">
                  {moment(userData && userData.createdAt).format("Do MMM, YYYY")}
                </div>
                <div className="f12-400">
                  {" "}
                  {moment(userData && userData.createdAt).format("LT")}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Seating Preference</div>
                <div className="f12-400">
                  {userData && userData.seating_preference}
                </div>
              </Col>
            </Row>
           
            <hr className="m-0" />
            <Row className="px-3">
            <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Requested date/time</div>
                  {userData?.service_type === "RESERVATION" ? (
                    <>
                     <div className="f15-700">
                    {userData?.service_type === "SEATING"
                      ? ""
                      : moment(userData?.reservationTime).format(
                          "Do MMMM YYYY"
                        )}
                  </div>
                  <div className="f15-700">
                    {userData?.service_type === "SEATING"
                      ? ""
                      : moment(userData?.reservationTime).format(
                          "hh:mm A"
                        )}
                  </div>
                    </>
                  ) : (
                    <>
                     <div className="f12-400">
                  {moment(userData && userData.createdAt).format("Do MMM, YYYY")}
                </div>
                <div className="f12-400">
                  {" "}
                  {moment(userData && userData.createdAt).format("LT")}
                </div>
                    </>
                  )} 
                </Col>
                <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">User Location</div>
                <div className="ml-4 pl-1">
                  <Image
                    fluid
                    src={require("../../../../../assets/images/ActionImages/maps-and-flagsred.png")}
                    alt="Location Icon"
                    width="13px"
                    title="Location"
                  />
                </div>
              </Col>
              {(userData && userData.diner_status === "CANCELLED") ||
              (userData && userData.diner_status === "REJECTED") ? (
                <Col lg={3} className="py-3"></Col>
              ) : (
                <Col lg={3} className="py-3">
                  <div className="f9-400 mb-1">Total wait time</div>
                  <div className="d-flex justify-content-center align-items-center enTimesLbl">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/hourglass.svg")}
                      alt="Edit"
                      title="Edit"
                      width="9px"
                    />
                    <span className="f10-500 text-dark pl-2">
                      {userData && userData.diner_status === "NOTSEATED"
                        ? time_convert(minutes)
                        : seated_time_difference(minutesSeated)}
                    </span>
                  </div>
                </Col>
              )}
              
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
            <Col lg={3} className="py-3">
                <div className="f9-400"></div>
                <div className="d-flex flex-wrap">
                  {/* <Button variant="link" className="enIconBtn mr-3 mb-3">
                  
                    <Image
                      src={require("../../../../../assets/images/UserManagement/phone.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button> */}
                  {/* <CallingButtonPopup sendData={userData} /> */}
                  {/* <Button variant="link" className="enIconBtn mr-3 mb-3">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/email.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button> */}
                  {/* <SuperAdminSmsAdmin
                    first_name={
                      userData &&
                      userData.user_details &&
                      userData.user_details.name
                    }
                    mobile_number={
                      userData &&
                      userData.user_details &&
                      userData.user_details.mobile_number
                    }
                  /> */}
                  {/* <Button variant="link" className="enIconBtn mr-3 mb-3">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/notification.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button> */}
                  {/* <CustomSuperAdminNotification
                    _id={userId}
                  ></CustomSuperAdminNotification> */}
{/* 
                  <Button variant="link" className="enIconBtn mr-3 mb-3">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/forum.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button> */}
                  {userData && userData.diner_status !== "CANCELLED" ? (
                    <Button
                      variant="link"
                      className="enIconBtn mr-3 mb-3"
                      onClick={onClickshowEdit}
                    >
                      <Image
                        src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>
                  ) : (
                    <> </>
                  )}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Table / Room No.</div>
                <div className="f12-400">
                  Room No. - {userData && userData.room_number} /
                </div>
                <div className="f12-400">
                  Table no. - {userData && userData.table_number}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Special Occasion</div>
                <div className="f12-400">{userData && userData.occasion}</div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="f13-400">
                  <span className="enYellowDot mr-1"></span>
                  {userData && userData.diner_status}
                </div>
              </Col>
            </Row>
          </div>
          <div className="f18-700 pt-5 pb-3"> Details</div>
          <div className="enGrayBorderBox">
            <Row className="px-3">
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Phone Number</div>
                <div className="f15-700 pb-3">
                  {userData &&
                    userData.user_details &&
                    userData.user_details.country_code +
                      " " +
                      userData.user_details.mobile_number}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Request Number</div>
                <div className="f15-700 pb-3">
                  #{userData && userData.diner_id}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">User status</div>
                <div className="f15-700 pb-3"></div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Requested date/time</div>
                <div className="f15-700">
                  {moment(userData && userData.reservationTime).format(
                    "Do MMM, YYYY"
                  )}
                </div>
                <div className="f15-700">
                  {moment(userData && userData.reservationTime).format("LT")}
                </div>
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
             
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Created date/time</div>
                <div className="f15-700">
                  {" "}
                  {moment(userData && userData.createdAt).format("Do MMM, YYYY")}
                </div>
                <div className="f15-700">
                  {" "}
                  {moment(userData && userData.createdAt).format("LT")}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Changed date/time</div>
                <div className="f15-700">
                  {moment(userData && userData.updatedAt).format("Do MMM, YYYY")}
                </div>
                <div className="f15-700">
                  {moment(userData && userData.updatedAt).format("LT")}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Point of entry</div>
                <div className="f15-700">
                  {userData && userData.pointOfEntry}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Reason for cancellation</div>
                <div className="f15-700">
                  {userData && userData.cancelReason}
                </div>
              </Col>
            </Row>
            {/* <Row className="px-3">
             
            </Row> */}
          </div>
          <div className="f18-700 pt-5 pb-3"> View Audit log</div>
          <div className="enGrayBorderBox">
            <Table responsive className="enAuditLogTBL">
            <tr>
                      <th className="">
                        <div className="f12-500">Date</div>
                      </th>
                      <th>
                        <div className="f12-500">Operation</div>
                      </th>
                      <th>
                        <div className="f12-500"></div>
                      </th>
                    </tr>
              {userData &&
                userData.auditLogs &&
                userData.auditLogs.map((log, index) => (
                  <Fragment key={index}>
                    
                    <tr>
                      <td>
                        <div className="f12-500">
                          {moment(log.timestamp).format("Do MMM, YYYY")}
                        </div>
                        <div className="f12-500">
                          {moment(log.timestamp).format("LT")}
                        </div>
                      </td>
                      <td>
                        <div className="f12-500">{log.message}</div>
                      </td>
                      <td>
                        <div className="f12-500">{log.initiator}</div>
                        {/* <div className="f12-500">123123123123</div> */}
                      </td>
                    </tr>
                  </Fragment>
                ))}
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewDiner;
